import { composeValidators, emailValidator, textValidator } from 'app/components/Form/utils/validators';
import Login from 'app/i18n/Login';

export const LOGIN_FORM_RULES = {
  email: {
    validate: composeValidators(
      textValidator('PROCURE_2001'),
      emailValidator('PROCURE_2002'),
    ),
  },
  password: {
    required: {
      value: true,
      message: 'PROCURE_2003',
    },
  },
};
